import React, { useEffect, useState } from "react";
import UploadPaymentDetailsPopup from "../../../../component/popups/upload_payment_details";
import { useLocation } from "react-router-dom";

const NeftDetails = props => {
  const location = useLocation();
  const [documentBulk, setDocumentBulk] = useState(false);
  const policyPreviousData = location.state?.data;
  const newData = location.state?.newData;

  // alert(JSON.stringify(newData))
  return (
    <>
      <div className="row mt-6">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h6>Vehicle Details</h6>
            </div>
            <div className="card-body">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  Vehicle Make & Model: <b>{newData?.make}</b> <b>{newData?.model}</b>
                </li>
                <li class="list-group-item">
                    User Name: <b>{newData?.insured_name}</b>
                </li>
                <li class="list-group-item">
                  Insurer Name: <b>{newData?.previous_insurer}</b>
                </li>
                {location.state?.from == "policy" && ( 
                  <>
                    <li class="list-group-item">
                    Renewal Due Date: {" "}
                      <b>{newData?.formatted_previous_policy_end_date}</b>
                    </li>
                  </>
                  )}
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">
              <h6>Bank Details</h6>
            </div>
            <div className="card-body">
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  Bank Name : <b>AXIS Bank</b>{" "}
                </li>
                <li class="list-group-item">
                  Bank Account No. :<b> 12345</b>{" "}
                </li>
                <li class="list-group-item">
                  IFSC Code : <b>IFSC000008</b>
                </li>
                <li class="list-group-item">
                  Branch : <b>Mumbai</b>
                </li>
                <li class="list-group-item">
                  Amount :{" "}
                  <b className="text-primary">
                   {newData?.total_premium_with_tax_add_on == undefined ?
                     Number(newData?.renewal_final_amt).toFixed(2)
                   :
                   Number(newData?.total_premium_with_tax_add_on).toFixed(2) 
                  }
                  </b>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-12 text-center mt-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              setDocumentBulk(true);
            }}
          >
            Upload Payment Details
          </button>
        </div>
      </div>
              
      <UploadPaymentDetailsPopup
        newData={newData}
        amount={
          newData?.total_premium_with_tax_add_on == undefined ?
          Number(newData?.renewal_final_amt).toFixed(2) 
        :
        Number(newData?.total_premium_with_tax_add_on).toFixed(2) 
        } 
        // amount={Number(newData?.total_premium_with_tax_add_on).toFixed(2)}
        show={documentBulk}
        handleClose={() => {
          setDocumentBulk(false);
        }}
      />
    </>
  );
};

export default NeftDetails;
